export const PATH_TRANSFER = "/member/transfer";

export const PATH_TRANSFER_ADD_BANK_ACCOUNT =
  "/member/transfer/add-bank-account";
